import type { DashboardSettingsResponseDto } from '@api'
import { useUnit } from 'effector-react'
import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { $creatorId } from '@/models/creators.ts'
import { rebillMessageService } from '@/modules/creator-settings/rebill-messages/service/rebill-message.ts'
import { useSettingsContext } from '@/modules/creator-settings/state/SettingsProvider.tsx'
import { handleError } from '@/utils/error'

export function useUpdateRebillMessageMinutesMutation() {
  const client = useQueryClient()
  const creatorId = useUnit($creatorId)

  const toast = useToast()
  const { settingsSortOptions } = useSettingsContext()

  return useMutation(
    (value: number) => {
      if (!creatorId) {
        throw new Error('Creator not selected')
      }

      return rebillMessageService.updateMinutes(creatorId, value)
    },
    {
      onMutate: (sendAfterMinutes) => {
        client.setQueryData<DashboardSettingsResponseDto | undefined>(
          ['settings', creatorId, settingsSortOptions],
          (state) => {
            if (!state) return state

            return {
              ...state,
              autoMessageRebilledFansSettings: {
                ...state.autoMessageRebilledFansSettings,
                sendAfterMinutes: sendAfterMinutes,
              },
            }
          },
        )
      },
      onSuccess: () => {
        toast.success('Settings updated')
      },
      onError: (error) => {
        handleError(error, 'Failed to update the message minutes')
        client.invalidateQueries(['settings', creatorId, settingsSortOptions])
      },
    },
  )
}
